module.exports = __webpack_public_path__ + "static/img/button.0f11d5d0.png";